
    function validarEmail2(valor: any) {
        //console.log("valor....", valor);
        if (/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(valor)) {
        //alert("La dirección de email " + valor + " es correcta.");
        console.log("La dirección de email ", valor, " es correcta.");
        return true;
        } else {
        //alert("La dirección de email " + valor + " es incorrecta.");
        console.log("La dirección de email ", valor, " es incorrecta.");
        return false;
        }
        //console.log(validarEmail);
    }
   
  
  
  export default validarEmail2;